import React, { useState } from 'react';
import { Modal, PdfViewerModalContent } from '../Modal';
import { FaDownload } from 'react-icons/fa';
import './resultados.css';

interface Anexo {
  Id: number;
  Nombre: string;
  FechaFin: string;
  FechaInicio: string;
  OtrosAspectos: string;
  TipoAcuerdo: string;
  FechaAprobacion: string;
}

interface ResultadosProps {
  anexoSeleccionadoData: Anexo | null;
  nit: string;
  contratoNombre: string;
}

const Resultados: React.FC<ResultadosProps> = ({ anexoSeleccionadoData, nit, contratoNombre }) => {
  const [showPdfModal, setShowPdfModal] = useState(false);

  if (!anexoSeleccionadoData) {
    return null;
  }

  const handleVerPDF = () => {
    setShowPdfModal(true);
  };

  const cerrarPdfModal = () => {
    setShowPdfModal(false);
  };

  return (
    <div className="gap-40">
      <div className="contenedor activo">
        <div className="numbercontainer">
          <span className="digit">2</span>
        </div>
        <div className="form-container">
          <p style={{ marginBottom: '20px', color: '#333333ff', width: '100%' }}>
            {window.CONST?.AnexosTarifarios?.textoResultados || 'Texto de ejemplo.'}
          </p>
          
          <div id="resultadoImagenesDiagnosticas" style={{ paddingTop: '20px' }}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{window.CONST?.AnexosTarifarios?.columnas?.nombreAnexo || 'Nombre del Anexo'}</th>
                  <th>{window.CONST?.AnexosTarifarios?.columnas?.tipoAcuerdo || 'Tipo de acuerdo'}</th>
                  <th>{window.CONST?.AnexosTarifarios?.columnas?.fechaAprobacion || 'Fecha de aprobación'}</th>
                  <th>{window.CONST?.AnexosTarifarios?.columnas?.estado || 'Estado'}</th>
                  <th>{window.CONST?.AnexosTarifarios?.columnas?.descargar || 'Descargar'}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{anexoSeleccionadoData.Nombre}</td>
                  <td>{anexoSeleccionadoData.TipoAcuerdo}</td>
                  <td>{anexoSeleccionadoData.FechaAprobacion && anexoSeleccionadoData.FechaAprobacion.trim() ? anexoSeleccionadoData.FechaAprobacion.split(' ')[0] : '-'}</td>
                  <td>
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      padding: '1px 8px',
                      backgroundColor: '#d4edda',
                      border: '1px solid #28a745',
                      borderRadius: '12px',
                      color: '#155724',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}>
                      <span style={{
                        display: 'inline-block',
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#28a745',
                        borderRadius: '50%',
                        marginRight: '8px'
                      }}></span>
                      {window.CONST?.AnexosTarifarios?.estadoAprobado || 'Aprobado'}
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={handleVerPDF}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#ff6600',
                        cursor: 'pointer',
                        fontSize: '14px',
                        padding: '0',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      <FaDownload style={{ fontSize: '16px' }} />
                      {window.CONST?.AnexosTarifarios?.verPDF || 'Anexo.pdf'}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal PDF */}
      <Modal
        isOpen={showPdfModal}
        title={`${anexoSeleccionadoData.Nombre}`}
        onClose={cerrarPdfModal}
        closeOnBackdropClick={false}
      >
        <PdfViewerModalContent
          nit={nit}
          contrato={contratoNombre}
          anexo={anexoSeleccionadoData.Nombre}
          onClose={cerrarPdfModal}
        />
      </Modal>
    </div>
  );
};

export default Resultados;
